import React from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';

import { EMPLOYEE_ATTENDANCE_LIST } from 'src/constants/EndpointUrls';
import BreadCrumb from 'jbc-front/components/BreadCrumb';
import { ActionButton } from 'jbc-front/components/ActionButton';
import { Strage } from 'jbc-front/components/icons';
import SearchDetector from 'src/components/SearchDetector';
import DetailSearchForm from 'src/components/DetailSearchForm';
import SearchFormPaginator from 'src/components/SearchFormPaginator';
import { REDUCER_NAME, fetchEmployees } from 'src/reducers/employees/employees';
import { takeEmployeesSearchQueries, FORM_NAME_EMPLOYEES_SEARCH } from 'src/reducers/searchForm';
import FilterEnrollmentStatusBtnList from 'src/features/Employees/components/EnrollmentStatusBtnList';
import { initSelectedEmployeeIds } from 'src/reducers/settings/coordinations';
import { ConfirmBtn } from 'src/buttons';
import EmployeeTable from './EmployeeTable';
import styles from './SettingEmployeeSync.scss';
import { useTranslation } from 'react-i18next';

const SettingEmployeeSync = props => {
  const { initialValues: formValues, location, resetValues, dispatch, title, saveEmployeeSyncSetting } = props;
  const { t } = useTranslation();

  return (
    <div>
      <SearchDetector
        location={location}
        didMountDetectingJudger={() => true}
        willReceivePropsDetectingJudger={(prevProps, nextProps) => nextProps.location !== prevProps.location}
        onDetect={() => {
          dispatch(fetchEmployees(takeEmployeesSearchQueries(formValues), initSelectedEmployeeIds));
        }}
      />

      <div className="l-main-title-wrap">
        <h1 className="m-title-main">{title}</h1>
      </div>

      <div className={styles.nameWrap}>
        <p>
          {t('features.Coordinations.components.SettingEmployeeSync.Set_employees_to_be_linked_with_JOBCAN_Attendance')}<br />
          {t('features.Coordinations.components.SettingEmployeeSync.If_not_set_attendance_information_from_JOBCAN_Attendance_will_not_be_entered')}
        </p>
      </div>

      <div className="l-contents-wrap">
        <div className="l-wrap-xl">
          <div className="u-mb20">
            <BreadCrumb>
              <BreadCrumb.Item label={t('features.Coordinations.components.SettingEmployeeSync.Attendance_list')} path={EMPLOYEE_ATTENDANCE_LIST} />
              <BreadCrumb.Item label={title} />
            </BreadCrumb>
          </div>

          <DetailSearchForm
            menuRender={() => <FilterEnrollmentStatusBtnList />}
            containsOtherSearch={false}
            formName={FORM_NAME_EMPLOYEES_SEARCH}
            resetValues={resetValues}
          />
        </div>
        <div className="l-wrap-xl">
          <ConfirmBtn
            widthAuto
            text={t('features.Coordinations.components.SettingEmployeeSync.Save_the_subject')}
            confirmText={t('features.Coordinations.components.SettingEmployeeSync.Save_the_checked_subjects')}
            handleConfirm={() => saveEmployeeSyncSetting()}
            as={ActionButton}
            icon={<Strage size={16} />}
          >
            {t('features.Coordinations.components.SettingEmployeeSync.Save_the_subject')}
          </ConfirmBtn>
        </div>
        <div className={classNames('l-wrap-xl', styles.list)}>
          <EmployeeTable />
          <SearchFormPaginator formName={FORM_NAME_EMPLOYEES_SEARCH} reducerName={REDUCER_NAME} />
        </div>
      </div>
    </div>
  );
};

export default connect()(SettingEmployeeSync);
